import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, BeenhereRounded, Visibility } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { Link } from 'react-router-dom';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 180 },
  { Header: 'Codigo', accessor: 'code' },
  { Header: 'Nombre marca', accessor: 'description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Mark(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [marks, setMarks] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function loadMarks() {
    setDataLoading(true);
    let response = await wsGetAll('logi/mark');
    setDataLoading(false);
    if (response.success) setMarks(response.data);
  }

  useEffect(() => {
    loadMarks();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open && (
        <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadMarks} />
      )}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_MARKS_STORE}
              component={
                <CardIcon color="primary">
                  <BeenhereRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Marcas {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Marcas"
              defaultWidth={1000}
              columns={columns}
              data={marks.map((mark, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.LOGI_MARKS_UPDATE}>
                        <Button justIcon round simple color="warning" onClick={() => setOpen(mark)}>
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.LOGI_MARKS_SHOW}>
                        <Link to={`${mark.id}`}>
                          <Visibility />
                        </Link>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.LOGI_MARKS_DELETED}>
                        <ButtonDelete entity="logi/mark" id={mark.id} reload={loadMarks} />
                      </AllowedGuard>
                    </div>
                  ),
                  code: mark.code,
                  description: mark.description,
                  state: mark.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
